import { useCallback } from "react";
import { useSiteReportConfiguration } from "../useSiteReportConfiguration";
import { LayerScopeConfig, ScopeType } from "src/js/stores/site/store";

export function useLayerScope(siteId: string, layerId: string) {
  const [config, { setConfiguration }] = useSiteReportConfiguration(siteId);

  const scopeConfig = config.layerScopes?.[layerId] ?? {
    scopeType: ScopeType.ON_SITE,
  };

  const setScopeConfig = useCallback(
    (newConfig: LayerScopeConfig) => {
      setConfiguration({
        ...config,
        layerScopes: {
          ...config.layerScopes,
          [layerId]: newConfig,
        },
      });
    },
    [config, setConfiguration, layerId]
  );

  return [scopeConfig, setScopeConfig] as const;
}
